import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { genURL, gengetURLTEST } from '../_getjson.js';
import SelectFix from './SelectFix';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
// import { AlertPopup } from "./AlertPopup";

import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Grid from '@mui/material/Grid';
require('./../_css/PopUpOther.css');

export const ReDate = (TimeStamp) => {
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate() < 10 ? '0' : '') + (myDate.getDate());
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}
export const ReDate2 = (date) => {
    var dateSp = date.split("/");
    var dataRe = dateSp[2] - 543 + "-" + dateSp[1] + "-" + dateSp[0];
    return dataRe
}
export const startdate = () => {
    var myDate = new Date();
    var date = "01"
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}
const mystyle = {
    paddingTop: '0px',
    // paddingLeft:'0px'
};
export default class Searchacc extends React.Component {

    constructor(props) {
        super(props);
        this.Docno1 = React.createRef();
        this.Docno2 = React.createRef();
        this.Typecus = React.createRef();
        this.Refdocno = React.createRef();
        this.Itemlist = React.createRef();
        this.state = {
            rows: [],
            Htext: '',
            _from: '',
            _STypecode: "",
            openBackdrop:false,
            DATE1: startdate(),
            DATE2: '',
        }
    }

    componentDidMount() {
        this.setState({ _from: this.props.from });
        setTimeout(() => {
            this.onSearch();
        }, 200);
        
    }

    onClose = (e) => {
        this.props.closePopup();
    }
    ViewCSTV = (DATA) => {
        switch (DATA) {
            case "CSOTHEREXPENSE": this.setState({ Htext: "บันทึกค่าใช้จ่ายอื่นๆ" }); this.setState({ _STypecode: "ap" }); return "CSOTHEREXPENSE/Search?"; break;
            case "CSOTHERINCOME": this.setState({ Htext: "บันทึกรายได้อื่นๆ" }); this.setState({ _STypecode: "ar" }); return "CSOTHERINCOME/Search?"; break;
            // case "CSRECEIPT": this.setState({ Htext: "บันทึกรายได้อื่นๆ" }); return "CSRECEIPT/SEARCH"; break;
            default: break;
        }
    }
    onSearch = async () => {
        this.setState({ openBackdrop: true })
        var url = this.ViewCSTV(this.props.from);
        /* url += "SITECODE="+this.props.userSite; */
        url += "&DATE1=" + ReDate2(this.state.DATE1);
        url += "&DATE2=" + ReDate2(this.state.DATE2);
        url += "&DOCNO1=" + this.Docno1.current.value;
        url += "&DOCNO2=" + this.Docno2.current.value;
            /* url +=  (this.state._STypecode=="ap"? "&APCODE=":"&ARCODE=") +this.Typecus.current.value; */
            /*  */url += "&REFDOCNO=" + this.Refdocno.current.value;
        url += "&top=" + this.Itemlist.current.value;
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
            if (res.data === undefined) {
                return;
            }
            if (res.data.length > 0) {
                var data = [];
                for (var i = 0; i < res.data.length; i++) {
                    data[i] = {
                        C0: i + 1,
                        C1: ReDate(res.data[i].DOCDATE),
                        C2: res.data[i].DOCNO,
                        C3: (this.state._STypecode === "ap" ? res.data[i].APCODE : res.data[i].ARCODE),
                        C4: (this.state._STypecode === "ap" ? res.data[i].ARNAME : res.data[i].ARNAME),
                        C5: res.data[i].REMARK,
                        C6: res.data[i].DEBTAMOUNT
                    }
                    if (i === res.data.length - 1) {
                        this.setState({ rows: data });
                        this.setState({ openBackdrop: false })
                    }
                }
            } else {
                var data = [];
                this.setState({ rows: data });
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            this.setState({ openBackdrop: false })
            console.log(error);
        });
    }
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar1": this.setState({ DATE1: data2 }); break;
            case "Calendar2": this.setState({ DATE2: data2 }); break;
        }
    }
    onSelectRow = (data) => {
        this.props.Get_Popup(data);
        this.props.closePopup();
    }
    KeyUp = (e) => {
        switch (e.target.id) {
            case "Docno1":
                this.Docno2.current.value = e.target.value;
                break;
            default:
                break;
        }
        // console.log(e.key);
        if (e.key === "Enter") {
            this.onSearch();
        }
    }
    render() {
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext}  </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="right">
                    <Grid container spacing={2}>
                            <Grid item xs={6} >
                                <MaterialUIPickers title="วันที่"
                                    DateValue={e => this.SelectSetData("Calendar1", e)}
                                    defaultdate={this.state.DATE1}
                                    Popup={true} />
                            </Grid>
                            <Grid item xs={6}>

                                <MaterialUIPickers title="ถึง"
                                    DateValue={e => this.SelectSetData("Calendar2", e)}
                                    defaultdate={this.state.DATE2}
                                    Popup={true} />

                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                    <span className="input-group-addon"> เลขที่เอกสาร : </span>
                                    <input type="text" className="form-control" id="Docno1" ref={this.Docno1} onKeyUp={this.KeyUp} />
                                    <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                    <span id="iconCreditCode" className="input-group-addon ">ถึง : </span>
                                    <input type="text" className="form-control" id="Docno2" ref={this.Docno2} onKeyUp={this.KeyUp} />
                                    <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                    <span className="input-group-addon"> {this.state._STypecode === "ap" ? "เลขบัตรเจ้าหนี้ : " : "เลขบัตรลูกหนี้ : "} </span>
                                    <input type="text" className="form-control" ref={this.Typecus} />
                                    <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                    <span className="input-group-addon">เอกสารอ้างอิง : </span>
                                    <input type="text" className="form-control" ref={this.Refdocno} />
                                    <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                    <span className="input-group-addon">จำนวนรายการ : </span>
                                    <input type="text" className="form-control" ref={this.Itemlist} />
                                    <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            </Grid>
                        <button className="PUSDbtn" onClick={this.onSearch.bind(null)}><i className="fas fa-search" > ค้นหา </i></button>

                        <div className="DivTable">
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูล"
                                }}
                                height='600'
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField='C0' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='C1'> วันที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='C2'> เลขที่เอกสาร </TableHeaderColumn>
                                {/* <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='C3'> รหัสลูกค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='C4'> ชื่อลูกค้า </TableHeaderColumn> */}
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='C5'> หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='C6'> รวมเงินทั้งสิ้น </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
